import { createGalleryBuilderCore } from './components/gallery-builder-core.js';
import { GalleryBuilderActions } from './components/gallery-builder-actions.js';
import { GalleryBuilderData } from './components/gallery-builder-data.js';
import { GalleryBuilderUI } from './components/gallery-builder-ui.js';
import { GalleryBuilderSelection } from './components/gallery-builder-selection.js';
import { GalleryBuilderUtils } from './components/gallery-builder-utils.js';
import { galleryVariantModal } from './components/gallery-variant-modal.js';
import { galleryFilterComponent } from './components/gallery-filter-component.js';
import { galleryInteractivePanel } from './components/gallery-interactive-panel.js';
import { galleryPreviewUI } from './components/gallery-preview-ui.js';

function galleryBuilder(initial_layout_count = 2, initial_orientation = 'horizontal', collectionId = null) {
  const component = {};

  const modules = [
    createGalleryBuilderCore(initial_layout_count, initial_orientation, collectionId),
    GalleryBuilderActions,
    GalleryBuilderData,
    GalleryBuilderUI,
    GalleryBuilderSelection,
    GalleryBuilderUtils
  ];

  modules.forEach((module) => {
    const descriptors = Object.getOwnPropertyDescriptors(module);
    Object.defineProperties(component, descriptors);
  });

  return component;
}

export default galleryBuilder;
export { galleryBuilder };

document.addEventListener('alpine:init', () => {
  Alpine.data('galleryBuilder', galleryBuilder);
  Alpine.data('galleryVariantModal', galleryVariantModal);
  Alpine.data('galleryFilterComponent', galleryFilterComponent);
  Alpine.data('galleryInteractivePanel', galleryInteractivePanel);
  Alpine.data('galleryPreviewUI', galleryPreviewUI);

});
